<template>
  <div :class="['home flex-column', programStyle]">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('forms') }}</span>
        <ul class="subtitle flex-row">
          <li @click="goToPrograms">{{ $t('programs') }}&nbsp;&gt;&nbsp;</li>
          <li @click="goToDealersList">{{ domain }}&nbsp;&gt;&nbsp;</li>
          <li @click="clearForm">{{ $t('forms') }}</li>
          <li @click="clearForm" v-if="selectedForm !== null">
            &nbsp;&gt;&nbsp;{{ selectedForm.configName }}&nbsp;&gt;&nbsp;
          </li>
          <li id="non-clickable" v-if="selectedForm !== null">{{ selectedForm.entity }}</li>
        </ul>
      </div>
      <div class="right" v-if="!selectedForm && appliedFilters && !formList">
        <FilterModal
          :appliedFiltersLength="appliedFilters.length"
          :valueMulti="activeFilters"
          @clear-filters="clearAllFilters"
          @updateMulti="updateMulti"
        />
        <div>
          <Magnifier class="search-icn"></Magnifier>
          <input
            class="search-input"
            :placeholder="$t('search')"
            v-model="search"
            type="text"
            v-debounce:1000ms="searchDebounce"
          />
        </div>
      </div>
    </div>
    <div v-if="forms && !selectedForm && !formList" class="flex-column">
      <div class="flex-column">
        <span class="forms-attention" v-if="submissionForms && submissionForms.length > 0">
          <img src="@/assets/new/stop_white.png" />
          {{ submissionForms.length }} Form(s) Require Your
          <span class="attention" @click="viewList(submissionForms)">Attention</span></span
        >
        <DataTable :headings="fieldFormsTH" :rows="forms" :perPage="numPerPage">
          <template v-slot:viewSlot="slotProps">
            <Eyecon class="eyecon" @click="view(slotProps)"></Eyecon>
          </template>
          <template v-slot:periSlot="slotProps">
            <span v-if="slotProps.row.configName">{{ slotProps.row.configName }}</span>
            <span v-else>{{ slotProps.row.period }}</span>
          </template>
        </DataTable>
        <div class="row-container" v-if="forms">
          <div class="row-info">
            {{ $t('viewing-firstrow-lastrow-of-forms-totalcount', [firstRow, lastRow, totalCount]) }}
          </div>
          <GPagination
            v-if="pageCount > 1"
            class="pagination"
            v-model="page"
            :pageCount="pageCount"
            @changed="getFormsDataWithLoad"
          />
          <div class="finalization-buttons" v-if="permissions[0].canFinalize">
            <button class="button-one" @click="getConfigsForFinalization">{{ $t('executive-finalization') }}</button>
          </div>
          <div class="finalization-buttons" v-if="permissions[0].canExecReport">
            <button class="button-one" @click="getConfigsForExecReport">{{ $t('executive-report') }}</button>
          </div>
          <div class="placeholder-div" v-else></div>
        </div>
      </div>
    </div>
    <FieldAppeal
      @exit="clearForm"
      :selectedForm="selectedForm"
      v-if="
        (!formList && selectedForm && selectedForm.formType === 'Appeal') ||
        (!formList && selectedForm && selectedForm.formType === 'Appeal-Legacy')
      "
    />
    <FieldAppealMultiple
      @updateSelectedForm="updateSelectedForm"
      @exit="clearForm"
      :formList="formList"
      v-if="formList && domain !== 'US EVR'"
    />
    <FieldWagoneerReview
      @exit="clearForm"
      :selectedForm="selectedForm"
      v-if="
        selectedForm &&
        (selectedForm.formType === 'Amenities' ||
          selectedForm.formType === 'Dealer Loaner' ||
          selectedForm.formType === 'Amenities-Legacy' ||
          selectedForm.formType === 'Dealer-Loaner-Legacy')
      "
    />
    <FieldAcknowledgement
      @exit="clearForm"
      :selectedForm="selectedForm"
      v-if="selectedForm && selectedForm.formType === 'Acknowledgement'"
    />
    <FieldComplex
      @exit="clearForm"
      :selectedForm="selectedForm"
      v-if="!formList && selectedForm && selectedForm.formType === 'Charging Equipment'"
    />
    <FieldComplexMultiple
      @updateSelectedForm="updateSelectedForm"
      @exit="clearForm"
      :formList="formList"
      v-if="formList && domain === 'US EVR'"
    />
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="modal-body flex-column">
        <form @submit.prevent="fullValidationCheck">
          <span class="title"> {{ $t('finalize-appeals') }} </span>
          <input required :placeholder="$t('reviewed-with-name')" v-model="execName" />
          <input required :placeholder="$t('reviewed-with-email-address')" v-model="execEmail" />
          <input :placeholder="$t('additional-email-recipients')" v-model="additionalRecipientsString" />
          <Multiselect
            v-if="finalizeConfigs"
            v-model="selectedConfig"
            :options="finalizeConfigs"
            class="multiselect single config"
            :placeholder="$t('select-option')"
            track-by="name"
            label="name"
            :showLabels="false"
            :allow-empty="false"
          ></Multiselect>
          <div>
            <span class="subtitle">{{ $t('results-will-be-available-to-view-on') }}</span>
            <div class="calendar-container flex-row">
              <v-date-picker
                v-model="availabilityTime"
                mode="dateTime"
                :popover="{ placement: 'right', visibility: 'click' }"
                :min-date="newDate"
                :input-props="{ class: 'w-full', placeholder: newDate, readonly: true }"
              />
            </div>
          </div>
          <div class="button-container flex-row">
            <button :class="[fullValidationCheck ? '' : 'disabled']" @click="finalizeAppeal" class="finalize">
              {{ $t('finalize') }}
            </button>
            <button @click="isModalOpen = false">{{ $t('cancel') }}</button>
            <div v-if="invalidPermissions">
              {{ $t('no-permission') }}
            </div>
          </div>
        </form>
      </template>
    </Modal>
    <Modal class="modal-screens" v-show="isExecReportModalOpen">
      <template v-slot:body class="modal-body flex-column">
        <form class="exec-report-form-container flex-column" @submit.prevent="fullValidationCheck">
          <span class="title">{{ $t('executive-summary-report') }}</span>
          <h4 class="subtitle">{{ $t('select-form') }}</h4>
          <Multiselect
            v-if="execReportConfigs"
            v-model="selectedConfig"
            :options="execReportConfigs"
            class="multiselect single config"
            :placeholder="$t('select-option')"
            track-by="name"
            label="name"
            :showLabels="false"
            :allow-empty="false"
          ></Multiselect>
          <div class="exec-report-button-container flex-row">
            <button @click="getExecReport" class="finalize">{{ $t('submit') }}</button>
            <button @click="isExecReportModalOpen = false">{{ $t('cancel') }}</button>
            <div v-if="invalidPermissions">
              {{ $t('no-permission') }}
            </div>
          </div>
        </form>
      </template>
    </Modal>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Multiselect from 'vue-multiselect';
import Eyecon from '@/assets/new/eye-con.svg';
import GPagination from '@/components/GComponents/GPagination.vue';
import Magnifier from '@/assets/icons/magnifier.svg';
import FilterModal from '@/components/FilterModal.vue';
import FieldAppeal from '@/components/Forms/Field/FieldAppeal.vue';
import FieldAppealMultiple from '@/components/Forms/Field/FieldAppealMultiple.vue';
import FieldWagoneerReview from '@/components/Forms/Field/FieldWagoneerReview.vue';
import FieldAcknowledgement from '@/components/Forms/Field/FieldAcknowledgement.vue';
import Modal from '@/components/Modal.vue';
import StatusFilters from '@/utils/formTableFilters/statusFilters.json';
import { mapState } from 'vuex';
import fieldFormsTH from '@/utils/tableHeaders/fieldFormsTH';
import FieldComplex from '@/components/Forms/Field/FieldComplex.vue';
import FieldComplexMultiple from '@/components/Forms/Field/FieldComplexMultiple.vue';

export default {
  name: 'FieldForms',
  components: {
    DataTable,
    Multiselect,
    Eyecon,
    GPagination,
    Magnifier,
    FilterModal,
    FieldAppeal,
    FieldWagoneerReview,
    Modal,
    FieldAppealMultiple,
    FieldAcknowledgement,
    FieldComplex,
    FieldComplexMultiple,
  },
  data() {
    return {
      numPerPage: 10,
      search: '',
      page: 1,
      rowCountDropValue: { label: this.$t('show-10'), value: 10 },
      forms: null,
      totalCount: null,
      permissions: null,
      multiFilterOptions: {},
      selectedForm: null,
      formList: null,
      isModalOpen: false,
      isExecReportModalOpen: false,
      execEmail: null,
      execName: null,
      additionalRecipientsString: null,
      availabilityTime: null,
      newDate: new Date(),
      invalidPermissions: false,
      loader: this.$loading.show(),
      bcFilter: [],
      salesDistrictFilter: [],
      serviceDistrictFilter: [],
      layoutFilter: [],
      statusFilter: [],
      periodFilter: [],
      appliedFilters: null,
      finalizeConfigs: null,
      execReportConfigs: null,
      selectedConfig: null,
      fieldFormsTH: fieldFormsTH(),
      submissionForms: null,
    };
  },
  methods: {
    view(slotProps) {
      this.selectedForm = slotProps.row;
    },
    viewList(forms) {
      this.formList = forms;
    },
    clearAllFilters() {
      if (this.multiFilterOptions.BC) {
        this.multiFilterOptions.BC.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.SalesDistrict) {
        this.multiFilterOptions.SalesDistrict.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.ServiceDistrict) {
        this.multiFilterOptions.ServiceDistrict.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Layout) {
        this.multiFilterOptions.Layout.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Period) {
        this.multiFilterOptions.Period.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Status) {
        this.multiFilterOptions.Status.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.DistrictDeVentes) {
        this.multiFilterOptions.DistrictDeVentes.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.DistrictDeService) {
        this.multiFilterOptions.DistrictDeService.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Disposition) {
        this.multiFilterOptions.Disposition.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Période) {
        this.multiFilterOptions.Période.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Statut) {
        this.multiFilterOptions.Statut.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      this.appliedFilters.length = 0;
      this.$store.state.activeFormFilters = this.multiFilterOptions;
    },
    updateMulti(updates) {
      this.loader = this.$loading.show();
      this.page = 1;
      this.multiFilterOptions = updates;
      this.$store.state.activeFormFilters = this.multiFilterOptions;
      this.setAppliedFilters();
      this.getFormsData();
    },
    updateSelectedForm(form) {
      this.selectedForm = form;
    },
    searchDebounce() {
      this.loader = this.$loading.show();
      this.page = 1;
      this.getFormsData();
    },
    getFormsDataWithLoad() {
      this.loader = this.$loading.show();
      this.getFormsData();
    },
    getFilters() {
      const BCFilters = [];
      const SalesDistrictFilters = [];
      const ServiceDistrictFilters = [];
      const LayoutFilters = [];
      const PeriodFilters = [];

      const { domain } = this;

      this.$store.dispatch('getFieldFilters', { domain }).then((res) => {
        res.bcFilters.forEach((filter) => {
          BCFilters.push({
            label: filter,
            checked: false,
          });
        });
        res.salesFilters.forEach((filter) => {
          SalesDistrictFilters.push({
            label: filter,
            checked: false,
          });
        });
        res.serviceFilters.forEach((filter) => {
          ServiceDistrictFilters.push({
            label: filter,
            checked: false,
          });
        });
        res.layoutFilters.forEach((filter) => {
          LayoutFilters.push({
            label: filter,
            checked: false,
          });
        });
        res.periodFilters.forEach((filter) => {
          PeriodFilters.push({
            label: filter,
            checked: false,
          });
        });

        if (this.selectedLanguage === 'en') {
          this.multiFilterOptions = {
            BC: BCFilters,
            SalesDistrict: SalesDistrictFilters,
            ServiceDistrict: ServiceDistrictFilters,
            Layout: LayoutFilters,
            Period: PeriodFilters,
            Status: StatusFilters,
          };
        } else {
          this.multiFilterOptions = {
            BC: BCFilters,
            DistrictDeVentes: SalesDistrictFilters,
            DistrictDeService: ServiceDistrictFilters,
            Disposition: LayoutFilters,
            Période: PeriodFilters,
            Statut: StatusFilters,
          };
        }
        this.createFilters();
      });
    },
    getFormsData() {
      const {
        domain,
        bcFilter,
        salesDistrictFilter,
        serviceDistrictFilter,
        layoutFilter,
        periodFilter,
        statusFilter,
        search,
      } = this;
      const page = this.page - 1;
      this.$store
        .dispatch('getFieldForms', {
          domain,
          bcFilter,
          salesDistrictFilter,
          serviceDistrictFilter,
          layoutFilter,
          periodFilter,
          statusFilter,
          page,
          search,
        })
        .then((res) => {
          this.forms = res.forms;
          this.permissions = res.permissions;
          this.totalCount = res.totalCount;
          this.submissionForms = res.curUserReviewForms;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          this.loader.hide();
        });
    },
    getConfigsForFinalization() {
      const loader = this.$loading.show();
      const { domain } = this;
      this.$store.dispatch('getConfigsForFinalization', { domain }).then((res) => {
        this.finalizeConfigs = res;
        this.isModalOpen = true;
        loader.hide();
      });
    },
    getConfigsForExecReport() {
      const loader = this.$loading.show();
      const { domain } = this;
      this.$store.dispatch('getConfigsForExecReport', { domain }).then((res) => {
        this.execReportConfigs = res;
        this.isExecReportModalOpen = true;
        loader.hide();
      });
    },
    goToPrograms() {
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$router.push({
        name: 'Programs',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    goToDealersList() {
      this.$router.push({
        name: 'Dealer-List',
      });
      this.$store.state.activeNavTab = this.activeNavBar[1];
    },
    createFilters() {
      this.bcFilter = [];
      this.serviceDistrictFilter = [];
      this.salesDistrictFilter = [];
      this.layoutFilter = [];
      this.statusFilter = [];
      this.periodFilter = [];

      this.$store.state.activeFormFilters = this.multiFilterOptions;
      this.setAppliedFilters();
    },
    clearForm() {
      this.loader = this.$loading.show();
      this.setAppliedFilters();
      this.getFormsData();
      this.selectedForm = null;
      this.formList = null;
    },
    finalizeAppeal() {
      const loader = this.$loading.show();

      if (this.fullValidationCheck) {
        const { domain, availabilityTime, execName, execEmail, additionalRecipientsString } = this;
        let additionalRecipients = [];

        if (additionalRecipientsString) {
          additionalRecipients = this.emailListConverter(additionalRecipientsString);
        }

        const params = {
          domain,
          configId: this.selectedConfig.id,
          formType: this.selectedConfig.formType,
          availabilityTime,
          execName,
          execEmail,
          additionalRecipients,
        };
        this.$store
          .dispatch('finalizeAppeals', params)
          .then((res) => {
            if (res === 'invalid_permissions') {
              this.invalidPermissions = true;
            } else {
              this.finalizeConfigs = null;
              this.selectedConfig = null;
              this.isModalOpen = false;
            }
          })
          .catch((error) => {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    emailListConverter(additionalRecipientsString) {
      return additionalRecipientsString.split(',').map((value) => value.trim());
    },
    getExecReport() {
      const loader = this.$loading.show();
      const { domain } = this;
      const configId = this.selectedConfig.id;
      this.$store.dispatch('getExecReport', { domain, configId }).then((res) => {
        if (res) {
          window.open(res);
          this.isExecReportModalOpen = false;
          loader.hide();
          this.$notify({
            group: 'primary',
            type: 'success',
            text: this.$t('report-generated-successfully'),
          });
        }
      });
    },
    setAppliedFilters() {
      this.bcFilter = [];
      this.salesDistrictFilter = [];
      this.serviceDistrictFilter = [];
      this.layoutFilter = [];
      this.periodFilter = [];
      this.statusFilter = [];

      const { bcFilter, salesDistrictFilter, serviceDistrictFilter, layoutFilter, periodFilter, statusFilter } = this;

      let length = 0;
      if (this.activeFilters) {
        if (this.activeFilters.BC) {
          this.activeFilters.BC.forEach((option) => {
            if (option.checked) bcFilter.push(option.label);
          });
        }
        if (this.activeFilters.SalesDistrict) {
          this.activeFilters.SalesDistrict.forEach((option) => {
            if (option.checked) salesDistrictFilter.push(option.label);
          });
        }
        if (this.activeFilters.ServiceDistrict) {
          this.activeFilters.ServiceDistrict.forEach((option) => {
            if (option.checked) serviceDistrictFilter.push(option.label);
          });
        }
        if (this.activeFilters.Layout) {
          this.activeFilters.Layout.forEach((option) => {
            if (option.checked) layoutFilter.push(option.label);
          });
        }
        if (this.activeFilters.Period) {
          this.activeFilters.Period.forEach((option) => {
            if (option.checked) periodFilter.push(option.label);
          });
        }
        if (this.activeFilters.Status) {
          this.activeFilters.Status.forEach((option) => {
            if (option.checked) statusFilter.push(option.label);
          });
        }
        if (this.activeFilters.DistrictDeVentes) {
          this.activeFilters.DistrictDeVentes.forEach((option) => {
            if (option.checked) salesDistrictFilter.push(option.label);
          });
        }
        if (this.activeFilters.DistrictDeService) {
          this.activeFilters.DistrictDeService.forEach((option) => {
            if (option.checked) serviceDistrictFilter.push(option.label);
          });
        }
        if (this.activeFilters.Disposition) {
          this.activeFilters.Disposition.forEach((option) => {
            if (option.checked) layoutFilter.push(option.label);
          });
        }
        if (this.activeFilters.Période) {
          this.activeFilters.Période.forEach((option) => {
            if (option.checked) periodFilter.push(option.label);
          });
        }
        if (this.activeFilters.Statut) {
          this.activeFilters.Statut.forEach((option) => {
            if (option.checked) statusFilter.push(option.label);
          });
        }
      }
      length =
        bcFilter.length +
        salesDistrictFilter.length +
        serviceDistrictFilter.length +
        layoutFilter.length +
        periodFilter.length +
        statusFilter.length;
      this.appliedFilters = {
        bcFilter,
        length,
        salesDistrictFilter,
        serviceDistrictFilter,
        periodFilter,
        layoutFilter,
      };
    },
  },
  computed: {
    ...mapState('global', ['programStyle']),
    ...mapState(['activeNavBar']),
    ...mapState({
      domain: (state) => state.global.programName,
      activeFilters: 'activeFormFilters',
    }),
    selectedLanguage() {
      return this.$store.state.languages.selectedLanguage.code;
    },
    pageCount() {
      if (this.forms) {
        const l = this.totalCount;
        const s = this.rowCountDropValue.value;
        return Math.ceil(l / s);
      }
      return null;
    },
    fullValidationCheck() {
      if (this.execEmail && this.execName && this.availabilityTime && this.selectedConfig) {
        return true;
      }
      return false;
    },
    firstRow() {
      if (this.forms.length > 0) {
        return (this.page - 1) * 10 + 1;
      }
      return 0;
    },
    lastRow() {
      return (this.page - 1) * 10 + this.forms.length;
    },
  },
  watch: {},
  created() {
    if (this.domain) {
      this.getFilters();
      this.getFormsData();
    } else {
      this.loader.hide();
      this.$router.push({
        name: 'Programs',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    list-style-type: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li {
      cursor: pointer;
    }
    #non-clickable {
      cursor: default;
    }
  }
}
.filter-wrapper {
  position: unset;
  ::v-deep {
    .modal-wrapper {
      top: 72px;
      left: 43px;
      right: 415px;
    }
  }
}

.logo {
  vertical-align: middle;
  width: 400px;
  margin-top: 35px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}

input {
  width: 300px;
  &:read-only {
    background: $primary-white !important;
  }
}

::placeholder {
  color: black;
  opacity: 1;
}
.placeholder-div {
  width: 130px;
}
.finalization-buttons {
  .button-one {
    margin-right: 20px;
  }
}
.modal-body {
  text-align: left;
  .title {
    text-transform: none;
    text-align: left;
    font-size: 22px;
  }
  input {
    &::placeholder {
      color: #aeaeae;
    }
    width: 96%;
    margin-top: 20px;
    border: 1px solid #dfe4e8;
  }
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  .subtitle {
    color: black;
    font-size: 20px;
    margin-top: 20px;
  }
  .calendar-container {
    margin-top: 10px;
  }
  .button-container {
    margin-top: 20px;
    .finalize {
      margin-right: 20px;
    }
  }
  .exec-report-form-container {
    height: 400px;
    align-items: center;
    justify-content: center;
  }
  .exec-report-button-container {
    margin-top: 50px;
    .finalize {
      margin-right: 20px;
    }
  }
}
.data-table {
  ::v-deep {
    th {
      white-space: normal;
    }
  }
}
.config {
  margin-top: 20px;
}
.forms-attention {
  padding: 5px 0;
  background-color: $red;
  color: $primary-white;
  display: flex;
  align-items: center;
  justify-content: center;
  .attention {
    text-decoration: underline;
    cursor: pointer;
    margin-left: 3px;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
</style>
